/**
 * LCW Subscription Hub
 * Dispara animação de entrada quando a section entra no viewport.
 * Respeita prefers-reduced-motion e theme editor.
 */
class LcwSubHub extends HTMLElement {
  connectedCallback() {
    // No theme editor, mostra estado final imediatamente
    if (window.Shopify && window.Shopify.designMode) {
      this.classList.add('is-visible');
      return;
    }

    // Se não tem animação solicitada, mostra estado final
    if (!this.hasAttribute('data-animate')) {
      this.classList.add('is-visible');
      return;
    }

    // Respeita prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('is-visible');
      return;
    }

    // Fallback pra navegadores sem IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            // Usa rAF pra garantir que o paint inicial aconteceu antes
            requestAnimationFrame(() => this.classList.add('is-visible'));
            obs.disconnect();
            break;
          }
        }
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    io.observe(this);
  }
}

if (!customElements.get('lcw-sub-hub')) {
  customElements.define('lcw-sub-hub', LcwSubHub);
}
